import createIcon from '../../createIcon';

/**
 * @component @name Threep
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMkg0LjAxQzIuOTEgMiAyLjAxIDIuOSAyLjAxIDRMMiAyMkw2IDE4SDIwQzIxLjEgMTggMjIgMTcuMSAyMiAxNlY0QzIyIDIuOSAyMS4xIDIgMjAgMlpNMTIgNkMxMy4xIDYgMTQgNi45IDE0IDhDMTQgOS4xIDEzLjEgMTAgMTIgMTBDMTAuOSAxMCAxMCA5LjEgMTAgOEMxMCA2LjkgMTAuOSA2IDEyIDZaTTE2IDE0SDhWMTMuNDNDOCAxMi42MiA4LjQ4IDExLjkgOS4yMiAxMS41OEMxMC4wNyAxMS4yMSAxMS4wMSAxMSAxMiAxMUMxMi45OSAxMSAxMy45MyAxMS4yMSAxNC43OCAxMS41OEMxNS41MiAxMS45IDE2IDEyLjYyIDE2IDEzLjQzVjE0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Threep = createIcon('Threep', [
  [
    'path',
    {
      d: 'M20 2H4.01C2.91 2 2.01 2.9 2.01 4L2 22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM12 6C13.1 6 14 6.9 14 8C14 9.1 13.1 10 12 10C10.9 10 10 9.1 10 8C10 6.9 10.9 6 12 6ZM16 14H8V13.43C8 12.62 8.48 11.9 9.22 11.58C10.07 11.21 11.01 11 12 11C12.99 11 13.93 11.21 14.78 11.58C15.52 11.9 16 12.62 16 13.43V14Z',
      key: '10f2sc',
    },
  ],
]);

export default Threep;
